import react, { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from 'react';
import {
  Player,
  ControlBar,
  ReplayControl,
  ForwardControl,
  CurrentTimeDisplay,
  TimeDivider,
  PlaybackRateMenuButton,
  VolumeMenuButton,
  BigPlayButton,
  playerActions,
  PlayToggle,
  Shortcut,
  LoadingSpinner,
  ProgressControl,
} from 'video-react';
import IMAGES from '../../../commons/constans/images';

import { play } from 'video-react/lib/actions/player';
import HeaderMenuVideo from './headerMenu';
import {
  Route,
  Router,
  Routes,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import ROUTERS from '../../constans/router';
import { convertUrlTObject, shareKakaoTalk } from '../../../utils/helpers';
import DialogConfirmDelComponent from '../../../pages/Video/components/detail/dialogConfirmDelVideo';
import { useDispatch } from 'react-redux';
import Loading from '../Loading';

import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
  isAndroid,
  isIOS,
} from 'react-device-detect';
import { deleteVideoRequest } from '../../../pages/Video/redux/actions';

type Props = {
  src: String,
  onClosePublic: Boolean,
  resetHandleClosePublic: Function,
  videoDetail: Object,
  deleteVideo: Function,
  userInfo: Object,
  handlePlayStatus: Function,
  videoRecommend: Boolean,
};

const VideoComponentCustom = ({
  src,
  onClosePublic,
  resetHandleClosePublic,
  videoDetail,
  deleteVideo,
  userInfo,
  handlePlayStatus,
  videoRecommend,
}: Props, ref) => {
  const playerRef = useRef();
  const navigate = useNavigate();
  const location = useLocation();
  const [isFullScreen, setIsFullScreen] = useState(true);
  const [dataVideoPlayer, setDataVideoPlayer] = useState({});
  const [statusDelete, setStatusDelete] = useState(false);
  const [statusVideo, setStatusVideo] = useState(false);
  const [loadingVideo, setLoadingVideo] = useState(true);
  const [startTime, setStartTime] = useState(0);
  const [isPlay, setIsPlay] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const backToVideoDetail = function () {
      window.nativeVideoFullScreenIos(false);
      if (isFullScreen) {
        navigate(ROUTERS.VIDEO_DETAIL_PATH(videoDetail?.id), {
          state: 'backFromVideoPlayer',
        });
      }
    };
    if (videoDetail?.video_message?.id && window.backToVideoDetail) {
      window.backToVideoDetail = backToVideoDetail;
    }

    return () => {
      window.backToVideoDetail = undefined;
    };
  }, [videoDetail?.id]);

  useEffect(() => {
    setIsFullScreen(true);
    setLoadingVideo(true);
    //handle full screen for ios
    window.nativeVideoFullScreenIos(true);
    console.log(isFullScreen, 'useEffect');
  }, []);

  useEffect(() => {
    onFullScreen(isFullScreen);
    // if (isAndroid) {
    // }
    if (!isFullScreen) {
      console.log('isFullScreen', isFullScreen);
      //handle exit full screen
      window.nativeVideoFullScreenIos(false);
    } else {
      window.nativeVideoFullScreenIos(true);
    }
  }, [isFullScreen]);

  useEffect(() => {
    setDataVideoPlayer(videoDetail);
  }, [videoDetail]);

  useEffect(() => {
    if (onClosePublic) {
      setIsFullScreen(true);
      resetHandleClosePublic(isFullScreen);
    }
  }, [onClosePublic]);

  useEffect(() => {
    console.log('loadingVideo', loadingVideo);
    if (loadingVideo) {
      setIsPlay(false);
      document.getElementsByClassName('video-react-loading-spinner')[0].classList.add('show-loading');
    }else{
      setIsPlay(true);
      if (document.getElementsByClassName('video-react-loading-spinner')[0]) {
        document.getElementsByClassName('video-react-loading-spinner')[0].classList.remove('show-loading');
      }
    }
  }, [loadingVideo])


  const handlePlay = () => {
    console.log(loadingVideo, 'loadingVideo');
    if (!loadingVideo) {
      setIsPlay(true);
    }
  };

  const handlePause = () => {
    setIsPlay(false);
    // setTimeout(() => {
      //   console.log('llog');
      //   document
      //     .getElementsByClassName('player-custom-video')[0]
      //     .classList.add('video-react-playing');
      //   document
      //     .getElementsByClassName('player-custom-video')[0]
      //     .classList.remove('video-react-paused');
      //     document
      // .getElementById('player-custom-video')
      // .classList.remove('background-video');
      // }, 3000);
    // document
    //   .getElementById('player-custom-video')
    //   .classList.add('background-video');
  };

  useEffect(() => {
    console.log('isPlay', isPlay);
    handlePlayStatus(isPlay);
    if (isPlay) {
      setLoadingVideo(false);
      window.nativePlayVideo();
      playerRef.current.handleMouseMove();
      // if (document.getElementsByClassName('video-react-loading-spinner')[0]) {
      //   document.getElementsByClassName('video-react-loading-spinner')[0].classList.remove('show-loading');
      // }
    }else{
      // setLoadingVideo(true);
    }
  }, [isPlay])

  const handleTimeUpdate = (duration) => {
    console.log('handleTimeUpdate', duration);
    setLoadingVideo(false);
    let controlBarActive = document.getElementsByClassName('video-react-user-inactive');
    console.log(controlBarActive, 'controlBarActive');
    if (controlBarActive.length > 0) {
      document
      .getElementById('player-custom-video')
      .classList.remove('background-video');
    }else{
      document
      .getElementById('player-custom-video')
      .classList.add('background-video');
    }
  };

  const handleSeeking = (duration) => {

    console.log(duration, 'handleSeeking');
    // if (document.getElementsByClassName('video-react-loading-spinner')[0]) {
    //   document.getElementsByClassName('video-react-loading-spinner')[0].classList.remove('show-loading');
    // }
  };

  const handleSeeked = (e) => {
    console.log(e.timeStamp, 'handleSeeked');
  };

  const handleEnd = () => {
    console.log(playerRef.current, 'handleEnd');
    // setStartTime(0);
    // document
    //   .getElementById('player-custom-video')
    //   .classList.add('background-video');
  };

  const handleClickPrev = () => {
    setIsFullScreen(false);
    navigate(-1);
  };

  const handleClickDel = () => {
    setStatusVideo(true);
    // console.log(location, 'location player handleClickDel');
    setStatusDelete(true);
  };

  const callDeleteVideo = () => {
    let data = {
      id: videoDetail.video_message.id,
    };
    // console.log(data, 'callDeleteVideo');
    // console.log(location, 'location player video99999999');
    // setIsFullScreen(false);
    window.nativeVideoFullScreenIos(false);
    dispatch(deleteVideoRequest(data));

    if (
      location?.state?.type &&
      location?.state?.type === '/video/message-maker'
    ) {
      navigate(location?.state?.type);
    } else {
      if (typeof location?.state?.type === 'string') {
        navigate(ROUTERS.ALBUM + `?type=${location?.state?.type || ''}`);
      } else {
        navigate(ROUTERS.ALBUM + `?type=''`);
      }
    }
  };

  const handleClose = () => {
    // console.log('handleClose');
    setStatusDelete(false);
  };

  const handleClickKakao = () => {
    let pathName = `/video/detail/${videoDetail.id}`;
    let linkRedirect = `${process.env.REACT_APP_URL}${pathName}`;
    // console.log(linkRedirect, 'linkRedirect');
    shareKakaoTalk(
      'Sphokidz',
      '캐릭터 천국, 스포키즈 영상메시지를 공유합니다',
      videoDetail?.video_url || '',
      videoDetail?.photo_url || '',
      linkRedirect
    );
  };
  const handleClickPublic = () => {
    console.log('handleClickPublic');
    // alert('handleClickPublic' + isFullScreen)
    if (isFullScreen) {
      setIsFullScreen(false);
    }
  };

  const onFullScreen = (rotate = false) => {
    if (rotate) {
      if (document.getElementsByClassName('video-react-icon-fullscreen')[0]) {
        document
          .getElementsByClassName('video-react-icon-fullscreen')[0]
          .click();
      }
      //       var video = document.createElement('video');
      // video.setAttribute('playsinline', 'playsinline');
    } else {
      if (
        document.getElementsByClassName('video-react-icon-fullscreen-exit')[0]
      ) {
        document
          .getElementsByClassName('video-react-icon-fullscreen-exit')[0]
          .click();
      }
    }
  };

  window.onPlayVideo = function () {
    if (!loadingVideo) {
      if (document.getElementsByClassName('video-react-video')[0]) {
        document.getElementsByClassName('video-react-video')[0].play();
      }
    }
  };


  // window.backToVideoDetail = function() {
  //   window.nativeVideoFullScreenIos(false);
  //   if (isFullScreen) {
  //     navigate(ROUTERS.VIDEO_DETAIL_PATH(videoDetail?.id), {
  //       state: 'backFromVideoPlayer'
  //     })
  //   }

  // }
  
  const handleClick = () => {
    console.log(223424234);
  }

  const toggleFullScreen = () => {
    setIsFullScreen(p => !p)
  }

  useImperativeHandle(ref, () => {
    return {
      showVideoFullScreen() {
        toggleFullScreen()
      },
    };
  }, []);

  
  const handleLoadStart = () => {
    setLoadingVideo(true);
    // document
    //   .getElementsByClassName('video-react-loading-spinner')[0]
    //   .classList.add('show-loading');
  };

  const onLoadEnd = () => {
    console.log('onLoadEnd');
  }

  const handleLoadedData = () => {
    console.log('handleLoadedData');
  };

  // const onHideControlbarVideo = () => {
  //   setTimeout(() => {
  //     document
  //       .getElementsByClassName('player-custom-video')[0]
  //       .classList.remove('video-react-user-active');
  //     document
  //       .getElementsByClassName('player-custom-video')[0]
  //       .classList.add('video-react-user-inactive');
  //     document.getElementsByClassName('player-custom-video')[0].click();
  //   }, 3000);
  // };

  const handleLoadedMetadata = () => {
    console.log('handleLoadedMetadata');
  };

  // useEffect(() => {
  //   if (document.getElementsByClassName('video-react-loading-spinner')[0]) {
  //     setLoadingVideo(true);
  //   }else{
  //     setLoadingVideo(false);
  //   }
  // }, [document.getElementsByClassName('video-react-loading-spinner')[0]])

  const handleSuspend = () => {
    setIsPlay(true);
    setLoadingVideo(false);
    // document.getElementsByClassName('video-react-loading-spinner')[0].classList.remove('show-loading');
  };

  const handleStalled = () => {
    console.log('handleStalled');
  };

  const subscribeToStateChange = (e) => {
    console.log('subscribeToStateChange', e);
  }

  const onCanplay = () => {
    console.log('oncanplay');
  }

  const getState = () => {
    console.log('getState');
  }

  useEffect(() => {
    console.log(playerRef, 'playerRef');
  }, [playerRef])

  const handleCanPlay = () =>{
    console.log('handleCanPlay');
  }

  const handlePlaying = () => {
    console.log('handlePlaying');
  }

  const handleWaiting = () => {
    console.log('handleWaiting');
    setLoadingVideo(true);
    document.getElementsByClassName('video-react-loading-spinner')[0].classList.add('show-loading');
  }

  const handleAbort = () => {
    console.log('handleAbort');
  }

  const handleSeekingTime = () => {
    console.log('handleSeekingTime');
  } 

  const handleActivate = () => {
    console.log('handleActivate');
  }
  const handleActivateTextTrack = () => {
    console.log('handleActivateTextTrack');
  }
  const handleChangeRate = () => {
    console.log('handleChangeRate');
  }
  const handleChangeVolume = () => {
    console.log('handleChangeVolume');
  }
  const handleForward = () => {
    console.log('handleForward');
  }

  return (
    <>
      <Player
        // playsinline
        ref={playerRef}
        controls={false}
        poster={videoDetail?.photo_url || ''}
        // startTime={0}
        // loop
        onActivate={() => handleActivate()}
        onActivateTextTrack={() => handleActivateTextTrack()}
        onChangeRate={() => handleChangeRate()}
        onChangeVolume={() => handleChangeVolume()}
        onForward={() => handleForward()}
        autoPlay
        // preload='auto'
        onCanplay={() => onCanplay() } 
        className={`player-custom-video`}
        onPlay={() => handlePlay()}
        getState={() => getState()}
        onPause={() => handlePause()}
        pause={statusVideo}
        // play={isPlay}
        onCanPlay={() => handleCanPlay()} //new
        onPlaying={() => handlePlaying()} 
        onWaiting={() => handleWaiting()}
        onAbort={() => handleAbort()}
        onTimeUpdate={(e) => handleTimeUpdate(e)}
        onSeeking={() => handleSeeking()}
        onSeeked={(e) => handleSeeked(e)}
        onEnded={() => handleEnd()}
        onLoadStart={() => handleLoadStart()}
        onLoadEnd={() => onLoadEnd()}
        onLoadedData={() => handleLoadedData()}
        onLoadedMetadata={() => handleLoadedMetadata()}
        videoId={`player-custom-video`}
        onSuspend={() => handleSuspend()}
        onStalled={() => handleStalled()}
        // toggleFullscreen={() => handleToggleFullscreen()}
        subscribeToStateChange={(e) => subscribeToStateChange(e)}
        onSeekingTime={()=>handleSeekingTime()}
        startControlsTimer={() => {console.log(11111111111111111111);}}
        playsInline
        webkit-playsInline
      >
        {/* {loadingVideo && <Loading width={`10%`} />} */}
        
        {/* <source src={videoDetail?.video_url || null} /> */}
        {
          videoDetail?.video_url && <source src={videoDetail?.video_url || null} />
        }
        <Shortcut clickable={false} onClick={() => handleClick()} dblclickable={false} />
        <BigPlayButton
          disabled
          position="center"
          className="big-play-button-custom"
        />
        {/* loadingVideo && <LoadingSpinner /> */}
        <DialogConfirmDelComponent
          statusDelete={statusDelete}
          handleClose={handleClose}
          callDeleteVideo={callDeleteVideo}
          className={`dialog-custom-button  ${
            isFullScreen ? 'dialog-custom-width' : ''
          }`}
        />
        <ControlBar
          className={`${
            isFullScreen ? 'control-bar-full-custom' : 'control-bar-custom'
          }`}
          autoHide={true}
          autoHideTime={3000}
        >
          <PlayToggle />
          <HeaderMenuVideo
            isFullScreen={isFullScreen}
            handleClickPrev={handleClickPrev}
            handleClickKakao={handleClickKakao}
            handleClickDel={handleClickDel}
            handleClickPublic={handleClickPublic}
            videoDetail={videoDetail}
            userInfo={userInfo}
            videoRecommend={videoRecommend}
            toggleFullScreen={toggleFullScreen}
          />
          <ReplayControl
            seconds={5}
            order={1.1}
            className="replay-control-custom"
          />
          <ForwardControl
            seconds={5}
            order={1.1}
            className="forward-control-custom"
          />
          <CurrentTimeDisplay order={4.1} disabled />
          <TimeDivider order={4.2} disabled />
          <PlaybackRateMenuButton
            rates={[5, 2, 1, 0.5, 0.1]}
            order={7.1}
            disabled
          />
          
          {/* {loadingVideo && <ProgressControl player={{width: 0}} />} */}
          <VolumeMenuButton disabled />
        </ControlBar>
      </Player>
    </>
  );
};

VideoComponentCustom.defaultProps = {
  // src: 'http://peach.themazzone.com/durian/movies/sintel-1024-surround.mp4'
  src: '',
  videoRecommend: false,
};
export default forwardRef(VideoComponentCustom);
